import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { useFeatureIsOn } from "@/app/featureFlags";
import { platformApi } from "@/app/platform";
import {
  IconESim,
  IconFlightService,
  IconHotelService,
  IconTripService,
} from "@/components/Icons";
import { HomeTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";
import type { SearchScope } from "@/types/types";

import { SearchNavigationButton } from "./SearchNavigationButton";

type NavOption = SearchScope | "eSim";

export const SearchNavigationButtons = () => {
  const intl = useIntl();

  const navigate = useNavigate();

  const handleClick = (option: NavOption) => {
    if (option === "flights") {
      navigate({
        to: "/flights/search",
      });

      rudderAnalytics.track(HomeTrackingEvents.USER_CLICKED_HOME_SERVICE, {
        service: "flight",
      });
    } else if (option === "hotels") {
      navigate({
        to: "/hotels/search",
      });

      rudderAnalytics.track(HomeTrackingEvents.USER_CLICKED_HOME_SERVICE, {
        service: "hotel",
      });
    } else if (option === "trips") {
      navigate({
        to: "/trips/search",
      });

      rudderAnalytics.track(HomeTrackingEvents.USER_CLICKED_HOME_SERVICE, {
        service: "tour",
      });
    } else if (option === "eSim") {
      platformApi.navigateToMiniApp("3488020210984303");

      rudderAnalytics.track(HomeTrackingEvents.USER_CLICKED_HOME_SERVICE, {
        service: "eSim",
      });
    }
  };

  return (
    <div className="flex gap-6">
      <SearchNavigationButton onClick={() => handleClick("flights")}>
        <IconFlightService className="size-9 shrink-0" />
        {intl.formatMessage({
          defaultMessage: "Flights",
          description: "Navigation label for the Flights section",
        })}
      </SearchNavigationButton>

      {useFeatureIsOn("hotels-flow") && (
        <SearchNavigationButton onClick={() => handleClick("hotels")}>
          <IconHotelService className="size-9 shrink-0" />
          {intl.formatMessage({
            defaultMessage: "Hotels",
            description: "Navigation label for the Hotels section",
          })}
        </SearchNavigationButton>
      )}

      {useFeatureIsOn("trips-flow") && (
        <SearchNavigationButton
          onClick={() => handleClick("trips")}
          badgeContent={intl.formatMessage({
            defaultMessage: "New",
            description: "Badge label marking a newly added trip as 'New'",
          })}
        >
          <IconTripService className="size-9 shrink-0" />
          {intl.formatMessage({
            defaultMessage: "Trips",
            description: "Navigation label for the Trips section",
          })}
        </SearchNavigationButton>
      )}

      {useFeatureIsOn("e-sim-navigation-link") && (
        <SearchNavigationButton onClick={() => handleClick("eSim")}>
          <IconESim className="size-9 shrink-0" />
          {intl.formatMessage({
            defaultMessage: "e-SIM",
            description: "Navigation label for the eSIM section",
          })}
        </SearchNavigationButton>
      )}
    </div>
  );
};
